import React from 'react';
import { DraggableModal } from '@ui/shared/components/Common/DraggableModal';
import IncidentReport from '../SessionDetails/IncidentReport';
import { getStore, useAppStore } from '../../stores/StoreContext';
import { useFullScreenMountNode } from '../../contexts/FullScreenContext';

/**
 * IncidentReportModal component
 * Displays a draggable modal containing the incident report form
 * 
 * @component
 * @example
 * return (
 *   <IncidentReportModal />
 * )
 */
function IncidentReportModal() {
    const AppStore = getStore('appStore');
    const isOpen = useAppStore((state) => state.isIncidentReportModalOpen);
    const mountNode = useFullScreenMountNode();

    const handleClose = () => {
        AppStore.closeIncidentReportModal();
    };

    return (
        <DraggableModal
            isOpen={isOpen}
            onClose={handleClose}
            title="Incident Report"
            initialSize={{ width: 500, height: 500 }}
            resizable={true}
            minimizable={true}
            minSize={{ width: 400, height: 300 }}
            maxSize={{ width: 500, height: 1000 }}
            constrainToContainer={false}
            id="incident-report-modal"
            mountNode={mountNode}
            contentStyle={{
                padding: '0'
            }}
        >
            <IncidentReport onClose={handleClose} />
        </DraggableModal>
    );
}

export default IncidentReportModal;
